import { useContext } from 'react'
import { VendorAuthContext, type VendorAuthContextValue } from '../auth-provider'

export function useAuth(): VendorAuthContextValue {
  const context = useContext(VendorAuthContext)
  if (!context) {
    throw new Error('useAuth must be used within a VendorAuthProvider')
  }
  return context
}
